import tr from "./tr.js";
import en from "./en.js";

export const LOCAL_STORAGE_KEY = "dekosta-public-language";

const TABLES = { tr, en };

/** @param {string} str @param {Record<string, string | number>?} vars */
export function interpolate(str, vars) {
  if (!str || vars == null) return str ?? "";
  return str.replace(/\{\{(\w+)\}\}/g, (_, key) =>
    vars[key] !== undefined && vars[key] !== null ? String(vars[key]) : `{{${key}}}`,
  );
}

/** @param {"tr"|"en"} lang @param {string} key @param {Record<string, string | number>?} vars */
export function getTranslation(lang, key, vars) {
  let s = TABLES[lang]?.[key];
  if (s == null) s = TABLES.en[key];
  if (s == null) s = key;
  return interpolate(String(s), vars);
}

/** @returns {"tr"|"en"} */
export function detectInitialLanguage() {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored === "tr" || stored === "en") return stored;
  } catch (_) {
    /* ignore */
  }
  const lang = typeof navigator !== "undefined" ? navigator.language || (navigator.languages && navigator.languages[0]) : "";
  const code = String(lang || "").split("-")[0].toLowerCase();
  if (code === "tr") return "tr";
  if (code === "en") return "en";
  return "en";
}

export { TABLES };
